import { UserNameDescriptionAndImageFragment } from "packages/shared/src/Utilities";

export const placeholderUser: UserNameDescriptionAndImageFragment = {
	id: "0",
	name: "X X",
	publicName: "X X",
	familyName: "X",
	givenName: "X",
	imageURL: "",
	imageKey: "",
	imageContentType: "",
	isCurrent: false,
	organizationName: "",
};

export const placeholderCurrentUser: UserNameDescriptionAndImageFragment = {
	...placeholderUser,
	name: "M E",
	publicName: "M E",
	familyName: "E",
	givenName: "M",
	isCurrent: true,
};
